import React from 'react';
import { Box, Button } from '@mui/material';
import { Logout } from '@mui/icons-material';

/**
 * Shared header for the gated application + status pages.
 *
 * A flat (non-rounded) deep-teal brand bar carrying the white Eqaya logo, the
 * page title, and a Log out action. Square edges on purpose — a rounded bar
 * reads as a clickable card, which this header is not.
 */
const DEEP_TEAL = '#185451';
const TEAL_DARK = '#134e4a';
const GRADIENT = `linear-gradient(135deg, ${DEEP_TEAL} 0%, ${TEAL_DARK} 100%)`;
const FONT = "'Figtree', system-ui, -apple-system, Segoe UI, Roboto, sans-serif";

export default function ApplicationHeader({ title, onLogout }) {
  return (
    <Box
      component="header"
      sx={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 2, px: { xs: 2, md: 3 }, height: 64,
        background: GRADIENT, color: '#fff',
        borderRadius: 0,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, minWidth: 0 }}>
        <Box
          component="img"
          src="/images/logo-eqaya-mark-light.png"
          alt="Eqaya Inc."
          sx={{ height: 32, width: 'auto', display: 'block', flexShrink: 0 }}
        />
        {title && (
          <Box
            component="span"
            sx={{
              fontFamily: FONT, fontWeight: 700, fontSize: '1.1rem',
              whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
            }}
          >
            {title}
          </Box>
        )}
      </Box>

      {onLogout && (
        <Button
          color="inherit"
          startIcon={<Logout />}
          onClick={onLogout}
          sx={{ textTransform: 'none', fontWeight: 600, flexShrink: 0 }}
        >
          Log out
        </Button>
      )}
    </Box>
  );
}
